import { Translation } from '@jsverse/transloco';
import enTranslations from '../assets/i18n/en.json';
import frTranslations from '../assets/i18n/fr.json';

/**
 * Creates an inline translation loader which may be used by Transloco
 * for the licensing application scope.
 */
export function createInlineLoader(languages: Array<string>): Record<string, () => Promise<Translation>> {
  // Store a mapping of all available translations. We need to store a map of these translation using import() and containing
  // the compile time path of the files. By using constant string paths, the compiler will pre-compile these files at build time
  // and modify the paths correctly. If we try to use something like import(`../../${language}.json`), the compiler is no longer
  // able to resolve the paths at build time. When resolving these paths at runtime we'll encounter errors as the paths change
  // once the app is built to the dist folder.
  const importMap: Record<string, () => Promise<Translation>> = {
    en: (): Promise<Translation> => Promise.resolve(enTranslations),
    fr: (): Promise<Translation> => Promise.resolve(frTranslations)
  };

  const translocoInlineLoader: Record<string, () => Promise<Translation>> = {};

  languages.forEach((language: string): void => {
    if (importMap[language]) {
      translocoInlineLoader[language] = importMap[language];
    } else {
      console.warn(`Language ${language} was not found in the import map and may be unsupported.`);
      translocoInlineLoader[language] = (): Promise<Translation> => Promise.resolve({});
    }
  });

  return translocoInlineLoader;
}
